import fontList from "../util/internal/font.json";


// Resolve a (family, style) pair to a downloadable font URL. Saved orders can
// reference fonts that have since been renamed or removed from font.json — in
// that case we fall back to the first available family/style instead of
// building `<bucket>undefined`, which silently registers a glyphless font and
// collapses the whole text→SVG→PNG pipeline (see makePngFromSvg zero-dim bug).
const resolveFontEntry = (family, style) => {
    const familyEntry = fontList.find(item => item?.fontFamily === family);
    const styleEntry = familyEntry?.fontStyle?.find(item => item?.style === style);
    if (styleEntry?.url) {
        return {family, style, url: styleEntry.url};
    }

    if (familyEntry?.fontStyle?.[0]?.url) {
        const fallbackStyle = familyEntry.fontStyle[0];
        console.warn(`getFontFace: style "${style}" not found for family "${family}"; falling back to "${fallbackStyle.style}".`);
        return {family, style: fallbackStyle.style, url: fallbackStyle.url};
    }

    const fallbackFamily = fontList.find(f => f?.fontStyle?.[0]?.url);
    if (fallbackFamily) {
        const fallbackStyle = fallbackFamily.fontStyle[0];
        console.warn(`getFontFace: family "${family}" not found in font.json; falling back to "${fallbackFamily.fontFamily}/${fallbackStyle.style}". This usually means the order was saved with a font that has since been removed.`);
        return {family: fallbackFamily.fontFamily, style: fallbackStyle.style, url: fallbackStyle.url};
    }

    return null;
};

export default async function getFontFace(family, style) {
    //console.log("family, style", family, style)
    const resolved = resolveFontEntry(family, style);
    if (!resolved) {
        throw new Error(`getFontFace: no usable font in font.json (requested ${family}/${style})`);
    }

    const name = `${resolved.family}-${resolved.style}`;
    const url = process.env.REACT_APP_GCS_BUCKET_PATH + resolved.url;

    // Wait for document.fonts.ready to be resolved
    await document.fonts.ready;

    const currentFontList = [];
    document.fonts.forEach((fontFace) => {
        currentFontList.push(fontFace.family);
    });

    if (currentFontList.includes(name)) {

        return name;
    } else {
        const fontFace = new FontFace(name, `url(${url})`);
        await fontFace.load();  // Ensure the font is fully loaded before adding
        document.fonts.add(fontFace);
        return name;
    }
}